import {Injectable} from "@angular/core";
import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";

@Injectable({ providedIn: 'root' })
export class ValidatorService {

  idNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const tcNumber = control.value;
      if (!tcNumber) {
        return null;
      }
      const tcNumberStr = String(tcNumber);
      if (!/^\d{11}$/.test(tcNumberStr)) {
        return { invalidTcNumber: true };
      }
      if (tcNumberStr.startsWith('0')) {
        return { invalidTcNumber: true };
      }
      const digits = tcNumberStr.split('').map(Number);
      const oddSum = digits[0] + digits[2] + digits[4] + digits[6] + digits[8];
      const evenSum = digits[1] + digits[3] + digits[5] + digits[7];
      const tenthDigit = (7 * oddSum - evenSum) % 10;
      if (tenthDigit !== digits[9]) {
        return { invalidTcNumber: true };
      }
      const totalSum = digits.slice(0, 10).reduce((acc, val) => acc + val, 0);
      const eleventhDigit = totalSum % 10;
      if (eleventhDigit !== digits[10]) {
        return { invalidTcNumber: true };
      }
      return null;
    };
  }

}
